export const AUDIENCE_TYPE_MARKETING = 'marketing';
export const AUDIENCE_TYPE_TRANSACTIONAL = 'transactional';
export const AUDIENCE_TYPE_ACQUISITION = 'acquisition';
export const AUDIENCE_TYPE_RE_ACQUISITION = 're_acquisition';
export const AUDIENCE_TYPE_COMPLIANCE = 'compliance';

export const AUDIENCE_TYPES_MAP = {
    [AUDIENCE_TYPE_MARKETING]: {
        name: AUDIENCE_TYPE_MARKETING,
        label: 'Marketing',
        description: `<li> Contacts have <strong class="font-semibold">opted-in</strong> to <strong class="font-semibold">marketing</strong> messages.</li>
        <li> Message is for promotional content such as discounts, coupons, offers, etc.</li>
        <li> You should have <strong class="font-semibold">explicit permission</strong> to text these numbers or <strong class="font-semibold">risk service disruption</strong>.</li>`,
    },
    [AUDIENCE_TYPE_TRANSACTIONAL]: {
        name: AUDIENCE_TYPE_TRANSACTIONAL,
        label: 'Transactional',
        description: `<li> Message is for support or in response to an explicit request from customer. </li>
        <li> Message <strong class="font-semibold">cannot</strong> contain any type of promotional content or <strong class="font-semibold">risk service disruption.</strong></li>`,
    },
    [AUDIENCE_TYPE_ACQUISITION]: {
        name: AUDIENCE_TYPE_ACQUISITION,
        label: 'Acquisition',
        description: `<li> Contacts have not <strong class="font-semibold">opted-in</strong> or <strong class="font-semibold">opted-out</strong> yet. </li>
        <li> This is the first time you are messaging these contacts.</li>`,
    },
    [AUDIENCE_TYPE_RE_ACQUISITION]: {
        name: AUDIENCE_TYPE_RE_ACQUISITION,
        label: 'Re-acquisition',
        description: `<li> Contacts have <strong class="font-semibold">opted-out</strong> of <strong class="font-semibold">marketing</strong> messages. </li>
                <li> Contacts should have done something to prompt reaching back out to them.</li>`,
    },
    // Messages carry one audience type beyond what campaigns offer: compliance,
    // reserved for consent management sends that no builder exposes yet.
    [AUDIENCE_TYPE_COMPLIANCE]: {
        name: AUDIENCE_TYPE_COMPLIANCE,
        label: 'Compliance',
        description: `<li> Message manages the contact's consent, such as an opt-in confirmation.</li>`,
    },
} as const;

export type MessageAudienceType = keyof typeof AUDIENCE_TYPES_MAP;

export const audienceTypes = () => Object.values(AUDIENCE_TYPES_MAP);

export function audienceTypeLabel(audienceType: MessageAudienceType): string {
    return AUDIENCE_TYPES_MAP[audienceType]?.label || 'Unknown';
}
